import React, {Component, useEffect, useState} from 'react';
import {Menu} from "./components/menu/menu";

// import { showlog, errorlog, extractErrorMessage } from "@liparistudios/js-utils";
import {NotificComponentHeader} from "./components/notific-component-header/notific-header-component";
import {MiddleHeaderComponent} from "./components/middle-header-component/middle-header-component";
import {cache, cachelog} from "./global";
import {navigateTo, router, RouteType} from "./routes";
import './index.css';
import './style/App.css';
import './style/header-style.css';
import './style/printable-a4.css';
import './style/small-device-style.css';
import {showlog} from "./utils";
import {WelcomePage} from "./pages/welcome/welcome-page";
import {SwitchComponent} from "./components/switch-component/switch-component";

function App() {
	const [currentPage, setCurrentPage] = useState<any>(() => {

		// in base all'url
		// return router().component;
		let PageComponent = router().component;
		return (<PageComponent/>);

		// return (<WelcomePage/>);
	});


	useEffect(() => {

		// doppio controllo
		try {

			let isDark = (
				!!window.localStorage.getItem('theme')
					? ( window.localStorage.getItem('theme') === 'dark' )
					: (
						// selezione in automatica in base al sistema
						(!!window.matchMedia("(prefers-color-scheme: dark)") && !!window.matchMedia("(prefers-color-scheme: dark)").matches)
					)
			);

			// @ts-ignore
			document.querySelector("html").setAttribute("data-theme", !!isDark ? 'dark' : 'light');

		}
		catch (e) {

		}
	});




	useEffect(() => {
		// cache.currentPage = {
		// 	url: '',
		// 	name: ''
		// };
		if(!!cache.currentPage) {
			showlog('impostata current page', currentPage?.type.name);
		}
	}, [currentPage]);


	showlog('RENDER APP');
	cachelog();
	return (
		<div className="App desktop">


			<div id={'header'}>
				<div className='title desktop'>
					<img
						src={'/imgs/logo.png'}
					/>
					<span>Mobile Agent Control Pannel</span>
				</div>
				<MiddleHeaderComponent/>
				{/*
				<div
					className='title mobile'
					onClick={(clickEvent: any) => {
						// setCurrentPage(navigateTo('welcome'));
						let newComponent: React.Component<unknown, unknown> = new Component( navigateTo('welcome') );
						setCurrentPage( newComponent );
					}}
				>
					<img
						src={'/imgs/menu.png'}
					/>
				</div>
				*/}



				<div>
					<span>Dark Mode</span>
					<SwitchComponent
						active={
							// controllo se gia impostato
							!!window.localStorage.getItem('theme')
								? ( window.localStorage.getItem('theme') === 'dark' )
								: (
									// selezione in automatica in base al sistema
									(!!window.matchMedia("(prefers-color-scheme: dark)") && !!window.matchMedia("(prefers-color-scheme: dark)").matches)
								)
						}
						onToggle={(newValue: boolean) => {
							let theme = !!newValue ? 'dark' : 'light';
							// @ts-ignore
							document.querySelector("html").setAttribute("data-theme", theme);
							localStorage.setItem("theme", theme);
						}}
					/>

					<NotificComponentHeader/>
				</div>


			</div>


			<div
				id={'page'}
			>
				<Menu
					activeMenuItemId={(!!cache.currentPage && (cache.currentPage.id === 'welcome')) ? 'w' : ''} // id del menu, al momento non funziona
					targetPage={(page: RouteType) => {
						setCurrentPage(navigateTo(page.id));
					}}
				/>
				<div
					id={'target-page'}
					className={
						(!!cache.currentPage && (cache.currentPage.id !== 'welcome'))
							? ''
							: ' hide'
					}
				>
					{ currentPage }
				</div>
			</div>

		</div>
	);
}

export default App;
